<template>
  <withTopNav :leftText="activityInfo?.title" class="text-13" fixed>
    <div
      @click="goToHistory()"
      style="padding-top: calc(env(safe-area-inset-top) / 2)"
      class="flex items-center fixed-rt-[8px_15px] z-10"
    >
      <span class="mr-2 text-[14px]">Histórico</span>
      <van-icon name="arrow" class="mt-1" />
    </div>
    <div class="flex flex-col h-full rebate">
      <div class="flex-1 flex flex-col overflow-y-auto">
        <div className="px-4 pt-6">
          <template v-if="activityInfo?.type == 'Realtime'">
            <Image :src="realtimeBanner" className="w-full" />
          </template>

          <template v-else>
            <div className="relative">
              <Image :src="nextDayBanner" className="w-full" />
              <div
                className="text-[#2F1780] absolute left-[168px] bottom-[7px] text-[11px] leading-[13px] flex items-center text-center"
              >
                <span
                  className="w-[18px] h-[16px] bg-[#FFDF12] py-[2px] rounded-[4px] font-bold"
                  >{{ (Math.max(days * 24 + +hours, 0) + "").padStart(2, "0") }}</span
                >
                <span className="text-white mx-[2px]">:</span>
                <span
                  className="w-[18px] h-[16px] bg-[#FFDF12] py-[2px] rounded-[4px] font-bold"
                  >{{ (Math.max(minutes, 0) + "").padStart(2, "0") }}</span
                >
                <span className="text-white mx-[2px]">:</span>
                <span
                  className="w-[18px] h-[16px] bg-[#FFDF12] py-[2px] rounded-[4px] font-bold"
                  >{{ (Math.max(seconds, 0) + "").padStart(2, "0") }}</span
                >
              </div>
            </div>
          </template>
        </div>

        <div class="px-4 py-3 container_bg">
          <template
            v-if="
              Number(rechargeOptions.data?.actualDeposit) >=
              Number(rechargeOptions.data?.requireDeposit)
            "
          >
            <div class="flex items-center mb-6 h-[88px] activity_bg justify-around">
              <Image :src="wallet_bg" class="w-[74px] h-[74px] mb-1" />
              <div class="self-end w-[200px]">
                <div class="text-[12px] text-white/75">
                  Deposite e participe da atividade
                </div>
                <div class="flex items-center justify-center mr-8">
                  <span class="text-white/75 text-[10px]"> Depósito Atual </span>
                  <span class="text-[#FFDF12] font-[600] block mb-1 text-[10px] mx-1">
                    {{ rechargeOptions.data?.actualAmout }}
                  </span>
                  <span class="text-white/75 text-[10px]">
                    / {{ rechargeOptions.data?.rechargeNum }}
                  </span>
                </div>
              </div>
              <div
                class="flex items-center recharge_btn w-24 h-[29px] justify-center self-center mt-[9px] mr-1"
                @click="
                  homeParams
                    ? $router.push(`/deposito?${homeParams}`)
                    : $router.push(`/deposito`)
                "
              >
                <span class="text-sm font-bold text-[#2F1780]">Depósito</span>
              </div>
            </div>
          </template>
          <div class="flex overflow-x-auto">
            <template v-if="gameCategorysOptions.list.length">
              <div
                v-for="item in gameCategorysOptions.list"
                :key="item.id"
                @click="activeCategory = item"
                class="flex flex-col items-center w-[20%] flex-none"
              >
                <Image
                  :src="`/static/images/category/${item.name}.png`"
                  class="w-9 h-9 mb-1"
                />
                <span
                  :class="[
                    'text-xs',
                    activeCategory?.id === item.id ? 'text-[#FFDF12]' : 'text-white/75',
                  ]"
                >
                  {{ item.name }}
                </span>
                <div
                  :class="[
                    'h-[2px] w-14 rounded-full mt-1',
                    activeCategory?.id === item.id ? 'bg-[#FFDF12]' : 'bg-transparent',
                  ]"
                ></div>
              </div>
            </template>
          </div>
        </div>
        <!-- 显示厅室列表信息 -->
        <div class="px-4 pt-4">
          <template v-if="roomListOptions.list.length">
            <div
              v-for="(item, index) in roomListOptions.list"
              :key="item.id"
              @click="navigateToDetail(item)"
              :class="[
                'rounded-lg p-3',
                index !== 0 ? 'mt-2' : '',
                index % 2 ? 'bg-[#2C7952]/20' : 'bg-[#2C7952]/40',
              ]"
            >
              <div class="flex items-center justify-between">
                <div class="flex justify-between items-center">
                  <Image
                    :src="`/static/images/defaults/${item.gameRoom}.png`"
                    class="w-[28px] h-[28px] mr-2"
                  />
                  <span class="text-white font-[500] text-[15px]">
                    {{ item.gameRoom }}
                  </span>
                </div>
                <div class="flex items-center">
                  <span class="text-white/75 text-[11px]"> Taxa de reembolso </span>
                  <span class="text-white font-[500] text-[15px] ml-1 mr-2">
                    {{ item.proportion }}%
                  </span>
                  <van-icon name="arrow" class="text-white text-[18px]" />
                </div>
              </div>
              <div class="flex justify-between items-center ml-9 mt-1 mb-2">
                <div class="text-white/50 text-[11px]">
                  <template v-if="item.lastLevel">
                    Recebendo a Taxa Máxima de Reembolso
                    <span class="mx-[2px]">{{ item.nextRebateRate }}%</span>
                  </template>
                  <template v-else>
                    Aposte
                    <span class="mx-[2px]">{{ item.needBetAmount }}</span>
                    para receber
                    <span class="mx-[2px]">{{ item.nextProportion }}%</span>
                  </template>
                </div>
                <van-progress
                  v-if="item.validAmount || item.needBetAmount"
                  :percentage="
                    Math.min(
                      (Number(item.validAmount) /
                        (Number(item.validAmount) + Number(item.needBetAmount))) *
                        100,
                      100
                    ) || 0
                  "
                  color="#FFDF12"
                  track-color="rgba(255, 255, 255, 0.3)"
                  :show-pivot="false"
                  class="w-[76px]"
                />
              </div>
              <div class="flex justify-between items-center text-sm">
                <div>
                  <span class="text-white/75 mr-1.5">Apostas Válidas</span>
                  <span class="text-white font-[500] text-[15px]">
                    {{ item.validAmount || formatter().format(0) }}
                  </span>
                </div>
                <div>
                  <span class="text-white/75 mr-1.5">Coletável</span>
                  <span
                    :class="[
                      'font-[500] text-[15px]',
                      +item.rewardAmount ? 'text-[#0BCF33]' : 'text-white',
                    ]"
                  >
                    {{ item.rewardAmount }}
                  </span>
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- 显示活动说明信息 -->
        <div class="pt-5 px-4 pb-20">
          <div class="flex items-center h-10 rounded-lg bg-[#2C7952]/70">
            <Image :src="activityCircleTip" class="w-6 h-6 mx-3" />
            <span class="text-white text-[14px] font-[600]">
              Descrição da Atividade
            </span>
          </div>
          <div class="py-2 text-white text-[12px] font-[400]">
            <ul>
              <li
                v-for="(item, index) in activityInfo?.desc || []"
                :key="index"
                class="break-words py-1"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>

        <!-- 领取奖励 -->
        <div
          class="fixed flex justify-between items-center px-4 bottom-0 h-15 bg-[#2C7952] rounded-tl-2xl rounded-tr-2xl w-[393px]"
        >
          <div class="flex">
            <Image :src="reward_bg" class="w-10 h-10" />
            <div class="flex flex-col justify-between ml-1.5">
              <span class="text-[12px] text-white/75">Pode ser coletado:</span>
              <span class="text-xl text-[#FFDF12]">
                {{ availableAmount || formatter().format(0) }}
              </span>
            </div>
          </div>
          <div
            @click="canReward && handleReward()"
            :class="[
              'w-22 h-9 rounded-xl leading-[36px] text-[14px] text-center mr-4',
              canReward ? 'bg-[#64F765] text-[#2F1780]' : 'text-white/50  bd-[1px_white]',
            ]"
          >
            Receber
          </div>
        </div>
      </div>
    </div>
  </withTopNav>
</template>

<script setup lang="tsx">
import withTopNav from "@/layouts/withTopNav.vue";
import { getActivityInfo, getActivityInfoWithoutAuth } from "@/api/rebate";
import { formatter } from "@/utils";
import debounce from "lodash-es/debounce";
import realtimeBanner from "./images/realtimeBanner.png";
import nextDayBanner from "./images/nextDayBanner.png";
import activityCircleTip from "./images/activityCircleTip.png";
import reward_bg from "./images/reward_bg.png";
import useTimeCountDown from "@/hooks/useTimeCountDown";
import wallet_bg from "./images/wallet_bg.png";
import Tip from "./tip.vue";
import showPopup from "@a/components/showPopup";
import { useUserInfo } from "@/store";
import showLoginOrReg from "@a/components/showLoginOrRegPopup";
import dayjs from "dayjs";
const router = useRouter();
const homeParams = localStorage.getItem("homeParams") || "";
const activityId: any = useRoute().query.activityId || "";
const activityInfo = ref<any>({});
const availableAmount = ref<any>("0.00");
const initialTime = ref(0);

const rechargeOptions = ref<any>({});
const gameCategorysOptions = ref<any>({
  list: [],
});
const roomListOptions = ref<any>({
  list: [],
});
const canReward = computed(() => availableAmount.value > 0);
const activeCategory = ref<any>(null);
const handleReward = debounce(async () => {
  const onSuccess = async () => {
    await getActivityInfoData();
  };
  showPopup(
    <Tip amount={availableAmount.value} activityId={activityId} onSuccess={onSuccess} />
  );
}, 500);

const goToHistory = () => {
  if (!useUserInfo().isLoggedin) {
    showLoginOrReg();
    return;
  }
  router.push(`/rebate/historial?activityId=${activityId}`);
};
// 跳转详情页
const navigateToDetail = (item: any) => {
  router.push({
    path: `/rebate/detail`,
    query: { activityId },
    state: {
      gameCategorys: JSON.parse(JSON.stringify(gameCategorysOptions.value.list)),
      roomList: JSON.parse(JSON.stringify(roomListOptions.value.list)),
      currentCategory: JSON.parse(JSON.stringify(activeCategory.value)),
      currentRoom: JSON.parse(JSON.stringify(item)),
    },
  });
};

// 获取活动信息
const getActivityInfoData = async () => {
  const params = {
    activityId: activityId,
  };
  const fn = useUserInfo().isLoggedin ? getActivityInfo : getActivityInfoWithoutAuth;
  const { code, data } = await fn(params);

  if (code === 1) {
    const d: any = {
      awardLimitSms: true,
      title: data.activityConfigName,
      desc: data.activityConfigDesc ? data.activityConfigDesc?.split("\n") : [],
    };
    d.type = data.rebateType || "Realtime";
    activityInfo.value = d;

    rechargeOptions.value = {
      data: {
        actualAmout: data.actualDeposit,
        rechargeNum: data.requireDeposit,
      },
    };
    availableAmount.value = data.amount || "0.00";
    gameCategorysOptions.value.list = data.categoryInfos || [];
    roomListOptions.value.list = gameCategorysOptions.value.list[0]?.detailList || [];
    activeCategory.value = gameCategorysOptions.value.list[0];
    if (data.rebateType == "Nextday" && data.nextDayTime) {
      initialTime.value = data.nextDayTime - dayjs().valueOf();
    }
  }
};
const { days, hours, minutes, seconds, changeTime } = useTimeCountDown(
  initialTime.value,
  getActivityInfoData
);
watch(activeCategory, () => {
  roomListOptions.value.list = activeCategory.value?.detailList || [];
});

watch(
  initialTime,
  (newVal) => {
    if (newVal > 1000) changeTime(newVal);
  },
  { once: true }
);

onMounted(() => {
  showLoadingToast({
    message: "Loading...",
  });
  try {
    getActivityInfoData();
  } finally {
    closeToast();
  }
});
</script>

<style lang="scss" scoped>
.rebate {
  .container_bg {
    background-image: url("./images/container_bg.png");
    background-size: 100%;
    background-position: bottom;
    background-repeat: no-repeat;
    .activity_bg {
      background-image: url("./images/rebate_bg.png");
      background-size: contain;
      background-position: center bottom;
      background-repeat: no-repeat;
    }
    .recharge_btn {
      background-image: url("./images/recharge_btn.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .reward_bg {
    background-image: linear-gradient(135deg, #51545b 0%, #2b3136 100%);
  }
}
</style>
